// src/pages/TurismoPage.js
import React from 'react';
import useSEO from '../hooks/useSEO';

const TurismoPage = () => {
  useSEO();

  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>Turismo Rural</h1>
      <p>Página em desenvolvimento - Por favor aguarde.</p>
    </div>
  );
};

export default TurismoPage;
